/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

function handleOnInputChange(prop, event) {

    prop.onInputChange(prop.identifier, event.target.value, prop.actions);

}

const DealerSearchInput = (props) => (
    <div className={props.style}>
        <FormattedMessage id={props.text} />
        <input
            onChange={(e) => handleOnInputChange(props, e)}
            type="text"
            value={props.value}
        />
    </div>
);

DealerSearchInput.displayName = 'DealerSearchInput';
DealerSearchInput.propTypes = {
    actions: PropTypes.object.isRequired,
    identifier: PropTypes.string.isRequired,
    onInputChange: PropTypes.func.isRequired,
    style: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};

export default DealerSearchInput;
